if (!customElements.get('custom-embroidery')) {
  class CustomEmbroidery extends HTMLElement {
    constructor() {
      super();

      this.textInputs = this.querySelectorAll(".custom-embroidery__text");
      this.body = this.querySelector(".custom-embroidery__body");

      this.tabButtons = this.querySelectorAll(
        ".custom-embroidery__preview-nav a"
      );
      this.tabContents = this.querySelectorAll(".custom-embroidery__preview-tab");

      this.ctaTriggers = this.querySelectorAll(".custom-embroidery__triggers a");
      this.ctaOpen = this.querySelector("[data-js-embroidery-show]");
      this.ctaClose = this.querySelector("[data-js-embroidery-hide]");

      this.addButtons = this.querySelectorAll("[data-add-btn]");
      this.editButtons = this.querySelectorAll("[data-edit-btn]");
      this.addAnotherPlacementBtn = this.querySelector(
        "[data-add-another-placement-btn]"
      );

      this.addedMessages = this.querySelectorAll(
        ".custom-embroidery__added-message"
      );

      // Bind event listeners
      this.ctaOpen.addEventListener("click", this.showEmbroidery.bind(this));
      this.ctaClose.addEventListener("click", this.hideEmbroidery.bind(this));

      this.querySelectorAll("[data-js-embroidery-color]").forEach((element) => {
        element.addEventListener("change", (event) => {
          const targetInput = event.target;
          const currentTab = targetInput.closest(
            ".custom-embroidery__preview-tab"
          );
          const color = targetInput.value;

          this.updateProperty("embroidery_color", color, currentTab);

          this.changePreviewColor(event);
        });
      });

      this.querySelectorAll("[data-js-embroidery-style]").forEach((element) => {
        element.addEventListener("change", (event) => {
          const targetInput = event.target;
          const currentTab = targetInput.closest(
            ".custom-embroidery__preview-tab"
          );
          const style = targetInput.value;

          this.updateProperty("embroidery_style", style, currentTab);

          this.changePreviewStyle(event);
        });
      });

      let firstBtn = document.querySelector('.custom-embroidery__cta');
      const addBtn = document.querySelector('[data-add-btn][disabled]');
      let secondBtn = document.querySelector('.custom-embroidery__cta.another-btn');

      function checkProductAdded() {
        if (firstBtn.textContent.trim() === 'ADDED!') {
          firstBtn.style.display = 'none';
          addBtn.style.display = 'none';
          secondBtn.style.display = 'inline-block';
        }
      }

      function refreshPage() {
        location.reload();
        ignoreCheck = true;
      }

      secondBtn.addEventListener('click', refreshPage);

      this.textInputs.forEach((textInput) => {
        const input = textInput.querySelector("input");
        const inputValue = input.value;
        this.updateRemainingLimit(input, inputValue);

        input.addEventListener("input", (event) => {
          const currentTab = input.closest(".custom-embroidery__preview-tab");
          this.updatePreviewText(event);
          this.updateProperty("embroidery_message", input.value, currentTab);
          this.updateAddBtnState(input, currentTab);
        });
      });

      this.restrictedWords = window.restrictions || [];

      this.tabButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          this.showTab(event);
        });
      });

      this.addButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          const currentTab = event.target.closest(
            ".custom-embroidery__preview-tab"
          );

          this.addEmbroideryToCart(
            currentTab,
            event.target.dataset.mainProductId
          );

          setTimeout(checkProductAdded, 2000)
          event.preventDefault();
        });
      });

      this.editButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          const currentTab = event.target.closest(
            ".custom-embroidery__preview-tab"
          );
          const embroideryInfo = currentTab.querySelector(
            "[data-embroidery-content]"
          );
          const propertyFields = embroideryInfo.querySelectorAll(".property");
          let item = {};
          let properties = {};

          for (const propertyField of propertyFields) {
            const propName = propertyField.dataset.propertyName;
            const propValue = propertyField.value;
            properties[propName] = propValue;
          }

          item.id = currentTab.dataset.cartKey;
          item.quantity =
            parseInt(
              embroideryInfo.querySelector("[data-cart-quantity]").value, 10
            ) || 1;
          item.properties = properties;

          btn.setAttribute("disabled", true);

          this.updateItemCart(item, currentTab);

          event.preventDefault();
        });
      });

      this.addAnotherPlacementBtn.addEventListener("click", (event) => {
        event.preventDefault();

        const unAddedPlacementTab = this.querySelector(
          ".custom-embroidery__preview-tab:not(.added):not(.active)"
        );

        if (!unAddedPlacementTab) return;

        const targetNavTrigger = this.querySelector(
          `.custom-embroidery__preview-nav [data-tab="${unAddedPlacementTab.dataset.navTrigger}"]`
        );

        if (!targetNavTrigger) return;

        targetNavTrigger.click();
      });

      this.addedMessages.forEach((addedMessage) => {
        const targetNavTrigger = this.querySelector(
          `.custom-embroidery__preview-nav [data-tab="${addedMessage.dataset.navTrigger}"]`
        );
        const targetTab = this.querySelector(
          `.custom-embroidery__preview-tab[data-${addedMessage.dataset.navTrigger}]`
        );
        const viewBtn = addedMessage.querySelector("[data-tab-view]");
        const editBtn = addedMessage.querySelector("[data-tab-edit]");

        viewBtn.addEventListener("click", (event) => {
          targetNavTrigger.click();

          event.preventDefault();
        });

        editBtn.addEventListener("click", (event) => {
          targetNavTrigger.click();

          targetTab.classList.add("edit");

          event.preventDefault();
        });
      });

      document.addEventListener(
        "CartUpdated",
        this.checkCartItemsForEmbroideryProduct.bind(this)
      );

      this.checkCartItemsForEmbroideryProduct();
    }

    showTab(event) {
      event.preventDefault();
      const targetTab = document.querySelector(
        `[data-${event.target.dataset.tab}]`
      );

      this.tabContents.forEach((content) => {
        content.classList.remove("active", "edit");
      });

      this.tabButtons.forEach((btn) => {
        btn.classList.remove("active");
      });

      targetTab.classList.add("active");
      event.target.classList.add("active");

      this.toggleAnotherPlacementBtn();

      this.toggleAddedMessages();
    }

    showEmbroidery(event) {
      event.preventDefault();

      // Unless a size option is already selected, force click on first size option when opening embroidery widget
      const sizeInputs = document.querySelector('.product-form__input-inner--size');
      if(sizeInputs) {
        const sizeName = sizeInputs.querySelector('input')?.getAttribute('name');
        if(sizeName) {
          const checkedRadio = document.querySelector(`input[name="${sizeName}"]:checked`);
          if (!checkedRadio) {
            sizeInputs?.querySelector('label')?.click()
          }
        }
      }

      this.ctaTriggers.forEach((button) => button.classList.remove("active"));
      event.target.classList.add("active");
      this.body.classList.add("active");
    }

    hideEmbroidery(event) {
      event.preventDefault();
      this.ctaTriggers.forEach((button) => button.classList.remove("active"));

      event.target.classList.add("active");
      this.body.classList.remove("active");
    }

    updatePreviewText(event) {
      const inputElement = event.target;
      let text = inputElement.value.trim();
      // Allow only letters and numbers, remove any other characters
      text = text.replace(/[^a-zA-Z0-9]/g, '');
      const words = text.split(/\s+/); // Split the text into individual words
      const previewContainer = document.querySelector(
        `[data-${inputElement.dataset.target}]`
      );

      const sanitizedWords = words.filter(
        (word) =>
          !this.restrictedWords.some((restricted) =>
            word.toLowerCase().includes(restricted)
          )
      );
      const sanitizedText = sanitizedWords.join(" ");

      inputElement.value = text;
      previewContainer.textContent = sanitizedText;

      this.updateRemainingLimit(inputElement, sanitizedText);
    }

    updateRemainingLimit(input, text) {
      const limitContainer = input
        .closest(".custom-embroidery__text")
        .querySelector("[data-limit]");
      const limit = limitContainer.dataset.limit;
      const remaining = input
        .closest(".custom-embroidery__text")
        .querySelector("[data-remaining]");
      const remainingChar = limit - text.length;

      remaining.textContent = remainingChar;
    }

    changePreviewColor(event) {
      const color = event.target.dataset.color;
      const svgTarget = event.target.dataset.target;
      const previewImage = document.querySelector(`[${svgTarget}]`);

      if (previewImage) {
        previewImage.style.fill = color;
      }
    }

    changePreviewStyle(event) {
      const fontClass = event.target.dataset.font;
      const target = event.target.dataset.target;

      document.querySelector(`[${target}]`).setAttribute("class", fontClass);
    }

    updateAddBtnState(input, currentTab) {
      const addBtn = currentTab.querySelector("[data-add-btn]");

      if (input.value.length > 0) {
        addBtn.removeAttribute("disabled");

        return;
      }

      addBtn.setAttribute("disabled", true);
    }

    updateProperty(propertyName, value, currentTab) {
      const propertyTag = currentTab.querySelector(
        `[data-property-name="${propertyName}"]`
      );

      propertyTag.value = value;
    }

    async addEmbroideryToCart(currentTab, mainProductId) {
      const embroideryInfo = currentTab.querySelector(
        "[data-embroidery-content]"
      );
      const propertyFields = embroideryInfo.querySelectorAll(".property");
      const addBtn = currentTab.querySelector("[data-add-btn]");
      const products = [];
      let product = {};
      let properties = {};
      let randomNumber = Math.floor((Math.random() * 1000000000) + 1);
      properties["grpid"] = "grp_" + randomNumber;

      // disable add button
      addBtn.setAttribute("disabled", true);

      // get main product info
      const mainProductInfo = this.getMainProductInfo();

      // add embroidery product id and quantity
      product.id = embroideryInfo.querySelector('input[name="id"]').value;
      product.quantity =  parseInt(embroideryInfo.querySelector("[data-cart-quantity]").value, 10) || 1;

      // add embroidery product properties
      for (const propertyField of propertyFields) {
        const propName = propertyField.dataset.propertyName;
        const propValue = propertyField.value;
        properties[propName] = propValue;
      }

      // Find matching barcode value based on data-variant-id
      const matchingBarcode = embroideryInfo.querySelector('.embroidery-variant-barcode-match[data-variant-id="' + mainProductInfo.id + '"]');
      if(matchingBarcode) {
        properties["embroidery_barcode"] = matchingBarcode.dataset.barcode;
      }

      // add embroidery product properties to product
      product.properties = properties;

      // add embroidery product to products array
      products.push(product);

      // add embroidery message to main product properties
      if (product.properties["embroidery_message"]) {
        if (!mainProductInfo.properties) {
          mainProductInfo.properties = {};
        }
        mainProductInfo.properties["Embroidery"] = product.properties["embroidery_message"];
      }

      // add grpid to main product properties
      mainProductInfo.properties["grpid"] = "grp_" + randomNumber;

      // add main product to products array
      products.push(mainProductInfo);

      // add items to cart
      this.addItemsToCart(products, currentTab);
    }

    async getCartInfo() {
      const response = await fetch("/cart.json");
      const data = await response.json();

      return data;
    }

    getMainProductInfo() {
      const productForm = document.querySelector(".product-form");
      const variantId = productForm.querySelector(".product-variant-id").value;
      const quantity =
        parseInt(productForm.querySelector("[data-cart-quantity]").value, 10) || 1;

      return { id: variantId, quantity: quantity };
    }

    addItemsToCart(items, currentTab) {
      const addBtn = currentTab.querySelector("[data-add-btn]");
      let formData = {
        "items": items,
      };

      console.log(formData);
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          window.theme.updateCart();
          addBtn.removeAttribute("disabled");
          //currentTab?.classList.add("added"); // stopped the added class from adding.
          currentTab?.classList.remove("edit");
          this.toggleAnotherPlacementBtn();
          this.checkCartItemsForEmbroideryProduct();
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    toggleAnotherPlacementBtn() {
      const unAddedPlacementTab = this.querySelector(
        ".custom-embroidery__preview-tab:not(.added):not(.active):not(.edit)"
      );
      const currentTab = this.querySelector(
        ".custom-embroidery__preview-tab.active"
      );

      if (
        unAddedPlacementTab &&
        currentTab.classList.contains("added") &&
        !currentTab.classList.contains("edit")
      ) {
        this.addAnotherPlacementBtn.classList.remove("hidden");

        return;
      }

      this.addAnotherPlacementBtn.classList.add("hidden");
    }

    toggleAddedMessages() {
      this.addedMessages.forEach((addedMessage) => {
        const targetTab = this.querySelector(
          `.custom-embroidery__preview-tab[data-${addedMessage.dataset.navTrigger}]`
        );

        if (
          targetTab.classList.contains("added") &&
          !targetTab.classList.contains("active")
        ) {
          addedMessage.classList.remove("hidden");

          return;
        }

        addedMessage.classList.add("hidden");
      });
    }

    async checkCartItemsForEmbroideryProduct() {
      const cartInfo = await this.getCartInfo();

      this.tabContents.forEach((tabContent) => {
        const embroideryEntry = tabContent.querySelector(".embroidery-entry");
        const variantId = embroideryEntry.querySelector('input[name="id"]').value;
        const placement = embroideryEntry.querySelector(
          'input[data-property-name="embroidery_placement"]'
        ).value;

        let cardEmbroideryProduct = cartInfo.items.filter(
          (item) =>
            item.variant_id == variantId &&
            item.properties["embroidery_placement"] == placement
        );

        if (cardEmbroideryProduct.length > 0) {
          this.updateEmbroideryStates(tabContent, cardEmbroideryProduct[0]);

          return;
        }

        this.updateEmbroideryStates(tabContent, null);
      });

      this.toggleAnotherPlacementBtn();
      this.toggleAddedMessages();
    }

    updateEmbroideryStates(targetTab, cartProduct) {
      const textField = targetTab.querySelector(".custom-embroidery__text input");
      const textValue = cartProduct
        ? cartProduct.properties["embroidery_message"]
        : "";
      const colorInput = cartProduct
        ? `[value="${cartProduct.properties["embroidery_color"]}"]`
        : "";
      const styleInput = cartProduct
        ? `[value="${cartProduct.properties["embroidery_style"]}"]`
        : "";
      const colorField = targetTab.querySelector(
        `.custom-embroidery__color input${colorInput}`
      );
      const styleField = targetTab.querySelector(
        `.custom-embroidery__style input${styleInput}`
      );

      textField.value = textValue;

      textField.dispatchEvent(new Event("input", { bubbles: true }));

      colorField.click();

      styleField.click();

      if (cartProduct) {
        //targetTab.classList.add("added"); // hide this to add multiple embroidery products

        targetTab.setAttribute("data-cart-key", cartProduct.key);
      } else {
        targetTab.classList.remove("added", "edit");

        targetTab.removeAttribute("data-cart-key");
      }
    }

    updateItemCart(item, currentTab) {
      const editBtn = currentTab.querySelector("[data-edit-btn]");

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      })
        .then((response) => {
          window.theme.updateCart();
          editBtn.removeAttribute("disabled");
          currentTab.classList.remove("edit");
          this.toggleAnotherPlacementBtn();
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  customElements.define("custom-embroidery", CustomEmbroidery);
}
